import React from 'react';
import { connect } from 'react-redux'
import debounce from 'debounce'
import moment from 'moment';

import { Button,Card, Col, Row, Table, Modal, Input } from 'antd';

import { _getDataReports, _downloadDataReport } from '../../services';
import { API_ENDPOINT } from '../../index';

class DataReportTable extends React.Component{

	render(){

		const { ezSuperuser, user } = this.props;

		const columns = [{
			title: 'Title',
			dataIndex: 'name',
			key: 'name',
		}, {
			title: 'Date Created',
			dataIndex: 'dateCreated',
			render: ( text ) => {

				return moment( text ).format('DD/MM/YYYY');

			},
		}, {
			title: 'Actions',
			key: 'actions',
			render: ( record, index ) => {

				if (record.version && record.version.major >= 2) {

					return (
						<Row type="flex" gutter={8}>
							<Col>
								{user.permissions.ezTech && <Button href={`/data-reports/${ record._id }`}>Edit</Button>}
							</Col>
							<Col>
								<Button onClick={() => this.handleDownloadClick(record._id)}>Download</Button>
							</Col>
						</Row>
					); 

				} else {
					
					return (
						<Row type="flex" gutter={8}>
							<Col>
								{user.permissions.ezTech && <Button href={`/data-reports/${ record._id }`}>Edit</Button>}
							</Col>
							<Col>
								<Button href={`${API_ENDPOINT}/api/admin/data-report/process/${record._id}`}>Download</Button>
							</Col>
						</Row>
					);
				}
			}
		}];

		
		return (
			<Card title={(
				<Row gutter={16} type="flex" align="middle">
					<Col>
						<h2 style={{ margin: 0 }}>Data Reports</h2>
					</Col>
					<Col>
						<Input
							style={{ width: 400, marginBottom: 0, marginRight: 'auto' }}
							placeholder="Search Data Report Titles"
							onChange={this.handleSearch}
						/>
					</Col>
					<Col>
						{user.permissions.ezTech && <Button href="/data-reports/new">
							Add Report
						</Button>}
					</Col>
				</Row>
			)}>

				<Table 
				columns={columns}
				dataSource={this.getReports()}
				/>
			</Card>
		)
	}

	constructor( props ){
		
		super(props);

		this.state = {
			reports: [],
			searchTerm: '',
		};

		this.setSearch = debounce(this.setSearch, 400)

	}

	componentDidMount(){
		this.getDataReports()
	}

	getDataReports = () => {
		
		const { searchTerm } = this.state
		
		_getDataReports({searchTerm})
		.then( res => {
			this.setState({
				reports: res.data.reports
			})
		})
	}

	getReports = () => {

		const { user } = this.props
		const { reports } = this.state
		
		if( user.permissions.ezTech ){
			return reports
		} else {
			return reports.filter( _report => _report.sharedWith.includes( user.local.email ))
		}

	}

	handleDownloadClick = (dataReportId) => {

		_downloadDataReport({dataReportId})
		.then(()=> console.log('success'))

		return Modal.info({
			centered: true,
			title: "Data Report",
			content: "The Data Report will be sent to your email once it's ready"
		})
	}

    handleSearch = (e) => {
        this.setSearch(e.target.value)
    }

    setSearch = (searchTerm) => {
        this.setState({
            searchTerm
        }, this.getDataReports)
    }
}

export default connect(
	state=>({
		user: state.user.data
	})
)(DataReportTable)


// WEBPACK FOOTER //
// ./src/components/data-report/table.js